module.exports = __webpack_public_path__ + "static/media/cookido_mobile.2fac9917.png";